/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Used for distinguishing between two Review Message types in requests/responses.
 */
export const ReviewMessageType = {
    Claim: 1,
    Contract: 2
} as const;
export type ReviewMessageType = typeof ReviewMessageType[keyof typeof ReviewMessageType];

